import mime from 'mime/lite';

/** Represents a file uploaded by the user, deriving its content type and file type extension from its file name. */
export class UploadedFile {
    fileContentType: string;
    fileType: string;
    uploadedFileName: string;
    file: string;

    /**
     * Creates an UploadedFile, resolving its MIME content type and uppercase file type extension from the given file name.
     * @param fileName The uploaded file's name, used to look up its MIME type and extension.
     * @param fileData The file's contents/data.
     */
    constructor(fileName: string, fileData: string) {
        this.file = fileData;
        this.uploadedFileName = fileName;
        this.fileContentType = "";
        this.fileType = "";

        let contentType = mime.getType(fileName);
        if (contentType) {
            this.fileContentType = contentType;

            let type: string = <string>mime.getExtension(contentType);
            this.fileType = type.toUpperCase();
        }
    }
}
